/**
 * Builds the inbox entry of the top menu. The entry exists only once the user has anything in
 * the inbox, so a person who never receives an item never sees it.
 */
import type { MenuWrapperItem } from '@insio/ui-toolkit';
import { navigation } from '@/navigation';
import type { TranslateFn } from '@/types/i18n';
import { InboxMenuLink } from '../components/InboxMenuLink';
import type { InboxSummary } from '../hooks/use-inbox-summary';

interface InboxMenuItemOptions {
  summary: InboxSummary;
  isActive: boolean;
  /** The `features.inbox` translator. */
  t: TranslateFn;
  /** Classes of the neighbouring menu links, so the entry lines up with them. */
  className: string;
}

export function inboxMenuItem({
  summary,
  isActive,
  t,
  className
}: InboxMenuItemOptions): MenuWrapperItem | null {
  if (summary.totalCount <= 0) return null;
  return {
    // The mobile drawer renders only the label, so the count travels in it there.
    label:
      summary.unreadCount > 0
        ? t('menu.labelWithUnread', { count: summary.unreadCount })
        : t('title'),
    icon: 'bell',
    href: navigation.notifications(),
    isActive,
    item: (
      <InboxMenuLink unreadCount={summary.unreadCount} isActive={isActive} className={className} />
    )
  };
}
